import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';

import reducers from '../reducers';
import middlewares from '../middlewares';
import logger from 'redux-logger';


export default (initialState) =>
  createStore(reducers, initialState, applyMiddleware(thunk,logger, ...middlewares));
